/* eslint-disable prettier/prettier */
/* eslint-disable */


import { keyframes } from "@mui/system";

const discoFlash = keyframes`
  0% { opacity: 0.2; background-color: rgba(50, 0, 0, 1); }
  25% { opacity: 0.3; background-color: rgba(0, 50, 0, 1); }
  50% { opacity: 0.4; background-color: rgba(0, 0, 50, 1); }
  75% { opacity: 0.5; background-color: rgba(50, 50, 0, 1); }
  100% { opacity: 0.6; background-color: rgba(50, 0, 50, 1); }
`;

export default discoFlash;
